import { action, Action, computed, Computed, memo, thunk, Thunk } from "easy-peasy";
import { Modbus as modbusSdk } from "coolremote-sdk";
import { isNil } from "lodash";
import { getSiteModbusUnitsWithDevices } from "../hooks/useModbusDevicesApi";

export interface IModbusUnitMap {
  [key: string]: any;
}

export interface IModbusUnitsModel {
  /** id-keyed map of the site's Modbus units (name, modbusDevice, isEngaged, paramTemplateData, ...). */
  allModbusUnits: IModbusUnitMap;
  setModbusUnits: Action<IModbusUnitsModel, IModbusUnitMap>;
  getModbusUnit: Computed<IModbusUnitsModel, (id?: string | null) => any | undefined>;
  /** Loads the site's Modbus units into the store (mirrors fetchSiteBacnetDevices). */
  fetchSiteModbusUnits: Thunk<IModbusUnitsModel, string>;
  /** Historical stats for a Modbus unit (mirrors getBacnetUnitsStats). */
  getModbusUnitsStats: Thunk<
    IModbusUnitsModel,
    { modbusUnitId: string; startTime: number; endTime: number; params?: any[] }
  >;
}

export const modbusUnitsModel: IModbusUnitsModel = {
  allModbusUnits: {},
  setModbusUnits: action((state, payload) => {
    state.allModbusUnits = payload;
  }),
  getModbusUnit: computed([(state) => state.allModbusUnits], (allModbusUnits) =>
    memo((id) => (isNil(id) ? undefined : allModbusUnits[id]), 100),
  ),
  fetchSiteModbusUnits: thunk(async (actions, siteId) => {
    const data = await getSiteModbusUnitsWithDevices(siteId);
    actions.setModbusUnits(data);
    return data;
  }),
  getModbusUnitsStats: thunk((actions, payload) => {
    const { modbusUnitId, startTime, endTime, params } = payload;
    return (modbusSdk as any).getModbusUnitsStats(modbusUnitId, startTime, endTime, params ?? []);
  }),
};
